import "./import/modules";
import "./import/ui";
import "./libs/js";
import "./pages/script";

//Js Бібліотеки
window.bootstrap = require('../../node_modules/bootstrap/dist/js/bootstrap.bundle.js');